module.exports = __webpack_public_path__ + "static/media/eyeLookUpRight.28e53bab.obj";